import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {PartnerParams, PartnerResponseSchema} from './partner.schema';
import {createApiResponseParser} from "../../api/api-response-parser.util";

@Injectable({ providedIn: 'root' })

export class PartnerApi {
  readonly #http = inject(HttpClient);
  readonly #baseUrl = environment.url;

  getPartners() {
    return this.#http
      .get(`${this.#baseUrl}/partners`, {
        params: {...PartnerParams},
      })
      .pipe(map(createApiResponseParser(PartnerResponseSchema)));
  }
}
